/**
 * Created by Rick Zhang on 10/20/2023.
 * Description:
 *  Edit relationshipType function
 */
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { EditRelationshipService } from './edit-relationship-dialog.service';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../redux';
import { EditRelationshipType, RelationshipTypeActionTypes } from '../../redux/actions/relationship-type.actions';
import { UntypedFormControl } from '@angular/forms';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { ToastService } from '../../widgets/toast/toast.service';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'edit-relationship-dialog',
    templateUrl: './edit-relationship-dialog.component.html',
    styleUrls: ['./edit-relationship-dialog.component.scss']
})
export class EditRelationshipDialogComponent implements OnInit, OnDestroy {
    dialogWidth = 480;
    nameDuplicated = false;
    name = new UntypedFormControl('');
    newRelationshipTypeName: string;
    opened = false;
    oldRelationshipTypeName: string;
    oldRelationshipTypeId: string;
    relationshipTypeName: string;
    relationshipTypeId: string;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _editRelationshipService: EditRelationshipService,
        private _store: Store<AppState>,
        private _toast: ToastService,
    ) {
    }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._editRelationshipService.dialogOpen$.subscribe(res => {
                this.relationshipTypeId = res.relationshipTypeId;
                this.oldRelationshipTypeName = this.relationshipTypeName = res.oldRelationshipTypeName;
                this.oldRelationshipTypeId = res.oldRelationshipTypeId;
                this.opened = true;
                this._changeDetectorRef.detectChanges();
            }),
            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => {
                this._onSubscribeActionMessage(action);
            }),
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    clickClose() {
        this.opened = false;
    }

    editRelationship() {
        this.name.setErrors(null);
        this.nameDuplicated = false;
        if (!this.name.value) {
            this.name.setErrors({
                required: true
            });
        } else if (this.name.value.length > 128) {
            this.name.setErrors({
                maxlength: true
            });
        } else {
            this._store.dispatch(new EditRelationshipType({
                oldRelationshipTypeName: this.oldRelationshipTypeName,
                oldRelationshipTypeId: this.oldRelationshipTypeId,
                newRelationshipTypeName: this.relationshipTypeName,
                relationshipTypeId: this.relationshipTypeId,
            }));
        }
    }

    onCancelBtnClick() {
        this.clickClose();
    }

    onRelationshipTypeNameChange(event) {
        this.nameDuplicated = false;
        this._changeDetectorRef.detectChanges();
    }

    private _onSubscribeActionMessage(action) {
        switch (action.type) {
            case RelationshipTypeActionTypes.EDIT_RELATIONSHIP_TYPE_FAILED:
                if (action.payload && action.payload.message.includes('ERR_DUPLICATE_RELATIONSHIP_TYPE')) {
                    this.nameDuplicated = true;
                    this._changeDetectorRef.detectChanges();
                } else {
                    this._showToast(action.payload, NotificationStyles.Error);
                }
                break;
            case RelationshipTypeActionTypes.EDIT_RELATIONSHIP_TYPE_SUCCESS:
                this.clickClose();
                this._showToast(StringLiteralsPipe.translate('general.edit_valid_relationship_type_successfully'), NotificationStyles.Success);
                break;
            default:
                break;
        }
    }

    private _showToast(toastMsg, state) {
        if (NotificationStyles[state]) {
            this._toast.notify({
                message: toastMsg,
                style: state
            });
        } else {
            return;
        }
    }
}
